//TODO Here is the module to complet in order to use the r-tree
//this module expose only one function
// @bounds {object} an object in the following form:
// @zoom {number} the current level of zoom defined on the map 
//  {
//    topLeft: {
//      lat: 42.42,
//      lng: 42.42
//    },
//    bottomRight: {
//      lat: 42.42,
//      lng: 42.42
//    }
//  }
//
//  @cb a callback when the necessary computation completed. This callback
//  expect tree arguments.
//  1 - an optional error (can be null)
//  2 - a list of estates in the following form
//    {
//      coordinates: {
//        lat: 42.42,
//        lng: 42.42,
//      },
//      id: 666
//    }
//  3 - a list of estate groups in the following form
//    {
//      ids: [42, 44, 43], the estate ids that match this position this field is optional
//      count: 3,
//      coordinates: {
//        lat: 42.42,
//        lng: 42.42
//      }
//    }
//This action is triggered by an update of the view port.
//When this event happens, the actions in the following file is dispatched
//`app/actions/updateViewPort.js`
//In this file you'll see two reference to the action `app/actions/mapSearch`.
//When implementing the real R-tree, be sure to remove this reference in order
//to not call two time the url `/estates/mapSearch`
export default (bounds, zoom, cb) => {
  const exempleEstate = {
    coordinates: {
      lat: 45.579018, 
      lng: -73.63805
    },
    id: 206
  }
  const exempleGroup = {
    coordinates: {
      lat: 45.4290244, 
      lng: -73.6624192
    },
    ids: [207, 208, 209]
  }
  cb(null, [exempleEstate], [exempleGroup])
}



/** WEBPACK FOOTER **
 ** ./app/api/r-tree.js
 **/